module.exports = __webpack_public_path__ + "img/zain_portrait.230f29a8.jpg";